import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-close-icon',
    templateUrl: './close-icon.component.html',
    styleUrls: ['./close-icon.component.scss'],
    standalone: false
})
export class CloseIconComponent implements OnInit {
  @Input() imageSrc!: string;
  @Input() imageWidth!: number;
  @Input() imageHeight!: number;
  constructor() {}

  ngOnInit() {
    this.imageSrc = '../../../../assets/Icons/close-icon-24x24.svg';
  }
}
